import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'

export default class StepNavEntry extends Component {
  static propTypes = {
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string,
    value: PropTypes.string,
  }

  @autobind
  handleClick() {
    if (this.props.onClick) {
      this.props.onClick({
        target: {
          value: this.props.value
        }
      })
    }
  }

  render() {
    const { active, dirty, title } = this.props
    return (
      <li
        className={classNames({ active, dirty })}
        onClick={this.handleClick}
      >
        {title}
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/StepNavItem.js